import { getCookies } from '@/utils/cookies'
// import Crm from '@/api/Crm'
const user = {
  state: {
    token: getCookies('authToken'),
    name: '',
    avatar: '',
    permission: [],
    isAdmin: '',
    dateTimeFormate: '',
    defaultTimeZone: '',
    googleMapApiKey: '',
    distanceUnit: '',
    isQBActive: false,
    isAweberActive: false,
    companyLocation: {},
    displayCityInschedule: true,
    displayZipInschedule: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSION: (state, permission) => {
      console.log('here2')
      console.log(permission)
      state.permission = permission
    },
    SET_MENULIST: (state, menuList) => {
      state.menuList = menuList
    },
    SET_ADMIN: (state, isAdmin) => {
      console.log('here1')
      console.log(isAdmin)
      state.isAdmin = isAdmin
    },
    SET_TIMEZONE: (state, timeZone) => {
      state.defaultTimeZone = timeZone
    },
    SET_DATETIMEFORMAT: (state, dateTimeFormat) => {
      state.dateTimeFormate = dateTimeFormat
    },
    SET_MAPAPI: (state, mapApi) => {
      state.googleMapApiKey = mapApi
    },
    SET_DISTANCEUNIT: (state, distanceUnit) => {
      state.distanceUnit = distanceUnit
    },
    SET_QBSTATUS: (state, isactive) => {
      state.isQBActive = isactive
    },
    SET_AWEBERSTATUS: (state, isactive) => {
      state.isAweberActive = isactive
    },
    SET_OFFICELOCATION: (state, location) => {
      state.companyLocation = location
    },
    SET_SCHEDULESETTING: (state, setting) => {
      state.displayCityInschedule = setting.displayCityInschedule
      state.displayZipInschedule = setting.displayZipInschedule
    }
  },
  actions: {
    SetName ({commit}, Name) {
      commit('SET_NAME', Name)
    },
    SetToken ({commit}, token) {
      commit('SET_TOKEN', token)
    },
    SetAvatar ({commit}, avatar) {
      commit('SET_AVATAR', avatar)
    },
    SetMenuList ({commit}, menuList) {
      commit('SET_MENULIST', menuList)
    },
    SetAdmin ({commit}, isadmin) {
      commit('SET_ADMIN', isadmin)
    },
    SetPermission ({commit}, permission) {
      commit('SET_PERMISSION', permission)
    },
    SetDistanceUnit ({commit}, distanceUnit) {
      commit('SET_DISTANCEUNIT', distanceUnit)
    },
    SetQBStatus ({commit}, isactive) {
      commit('SET_QBSTATUS', isactive)
    },
    SetAweberStatus ({commit}, isactive) {
      commit('SET_AWEBERSTATUS', isactive)
    },
    SetOfficeLocation ({commit}, officeLocation) {
      commit('SET_OFFICELOCATION', officeLocation)
    },
    GetUserPermission ({ commit, state }) {
      return new Promise((resolve, reject) => {
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js